import moment from "moment";
import { momentLocalizer } from "react-big-calendar";

// Loading a Moment locale changes its global default; keep this calendar isolated.
const previousLocale = moment.locale();
// eslint-disable-next-line global-require
require("moment/locale/pl");

moment.locale(previousLocale);

export const calendarLocalizer = momentLocalizer(moment);
export const CALENDAR_VIEW_LABELS = {
  month: "Miesiąc",
  week5: "5 dni",
  week6: "6 dni",
  week: "Tydzień",
  day: "Dzień",
};

export const normalizeCalendarView = view => (
  Object.prototype.hasOwnProperty.call(CALENDAR_VIEW_LABELS, view) ? view : null
);
export const getDefaultCalendarView = width => (width < 768 ? "day" : "week");

export const calendarMessages = {
  ...CALENDAR_VIEW_LABELS,
  date: "Data",
  time: "Godzina",
  event: "Zajęcia",
  allDay: "Cały dzień",
  work_week: "5 dni",
  previous: "Poprzedni",
  next: "Następny",
  yesterday: "Wczoraj",
  tomorrow: "Jutro",
  today: "Dzisiaj",
  agenda: "Plan zajęć",
  noEventsInRange: "Brak zajęć w tym terminie.",
  showMore: total => `+${total} więcej`,
};

const timeRange = ({ start, end }, culture, localizer) => (
  `${localizer.format(start, "HH:mm", culture)} – ${localizer.format(end, "HH:mm", culture)}`
);

export const calendarFormats = {
  timeGutterFormat: "HH:mm",
  dayFormat: "DD ddd",
  dayHeaderFormat: "dddd, D MMMM YYYY",
  monthHeaderFormat: "MMMM YYYY",
  dayRangeHeaderFormat: ({ start, end }, culture, localizer) => {
    const startFormat = start.getFullYear() === end.getFullYear() ? "D MMMM" : "D MMMM YYYY";
    return `${localizer.format(start, startFormat, culture)} – ${localizer.format(end, "D MMMM YYYY", culture)}`;
  },
  selectRangeFormat: timeRange,
  eventTimeRangeFormat: timeRange,
  eventTimeRangeStartFormat: ({ start }, culture, localizer) => `${localizer.format(start, "HH:mm", culture)} –`,
  eventTimeRangeEndFormat: ({ end }, culture, localizer) => `– ${localizer.format(end, "HH:mm", culture)}`,
  agendaTimeFormat: "HH:mm",
  agendaTimeRangeFormat: timeRange,
};
